export interface StringifyResult {
	value: string;
	error?: string;
}

export function stringifyValue(value: unknown): StringifyResult {
	try {
		// Handle null and undefined
		if (value === null || value === undefined) {
			return { value: "" };
		}

		// Handle strings - return as is without quotes
		if (typeof value === "string") {
			return { value };
		}

		// Handle numbers
		if (typeof value === "number") {
			return { value: value.toString() };
		}

		// Handle booleans
		if (typeof value === "boolean") {
			return { value: value.toString() };
		}

		// Handle functions
		if (typeof value === "function") {
			const funcStr = value.toString();
			// Format simple arrow functions with proper indentation
			if (funcStr.includes("() => {}")) {
				return { value: "() => {\n    }" };
			}
			return { value: funcStr };
		}

		// Handle objects and arrays
		if (typeof value === "object") {
			try {
				return { value: JSON.stringify(value) };
			} catch (e) {
				return {
					value: "",
					error: e instanceof Error ? e.message : "Failed to stringify object",
				};
			}
		}

		// For any other type, convert to string
		return { value: String(value) };
	} catch (e) {
		return {
			value: "",
			error: e instanceof Error ? e.message : "Failed to stringify value",
		};
	}
}
